import { render, staticRenderFns } from "./ModuleView.vue?vue&type=template&id=372962ac&scoped=true"
import script from "./ModuleView.vue?vue&type=script&lang=js"
export * from "./ModuleView.vue?vue&type=script&lang=js"
import style0 from "./ModuleView.vue?vue&type=style&index=0&id=372962ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372962ac",
  null
  
)

export default component.exports